/**
 * メニューマスター用 JS
 */
import gql from 'graphql-tag';

// マスタ画面 メニュー一覧
export const GET_MENU_MASTER_LIST = gql`
  query{
    GetMenuMaster{
        MenuMasterLists{
            menu_id
            sort_no
            parent_name
            child_name
            valid_flag
            title
            parent_id
            url
            external_url
            name
            icon_class
            display_member_class
            display_member_status
            external_link
            childhas
            futter_flag
            futter_title
        }
        ChatboxSetting
        LineSetting
        CardSetting
        MenuCount
    }
  }
`;

// 親メニュー取得 WEBの親取得と共用のGetMenuを使用
export const GET_MENU_PARENT = gql`
  query{
    GetMenuParent{
          id
          title
          class
          to
          name
          iconclass
          childhas
      }
  },
`;

// 登録情報変更
export const UPDATE_MENU_MASTER = gql`
    mutation(
        $UpdateMenuMaster: [UpdateMenuMaster]
        $SortFlg: Boolean
    ){
      UpdateMenuMaster(
          UpdateMenuMaster: $UpdateMenuMaster
          SortFlg: $SortFlg
      ){
          result
      }
    }
`;

// マスタ画面 登録データ登録
export const REGISTER_MENU_MASTER = gql`
mutation(
    $UpdateMenuMaster: [UpdateMenuMaster]
){
  RegisterMenuMaster(
    UpdateMenuMaster: $UpdateMenuMaster
  ){
      result
  }
}
`;
